import type { ActionMessage } from 'satcheljs';
import type { ActionMetaInfo } from 'mini-app-context';
import { addDatapointMiddleware, PerformanceDatapoint } from 'owa-analytics';

/* eslint-disable-next-line @typescript-eslint/no-explicit-any --
 * See aka.ms/mini-lint-errors
 *	> Unexpected any. Specify a different type.
 *	> Unexpected any. Specify a different type.
 *	> Unexpected any. Specify a different type. */
export function datapointMiddleware(next: any, metaInfo: ActionMetaInfo, ctx: any, ...args: any[]) {
    try {
        const actionMsg: ActionMessage = {
            type: metaInfo.name,
            dp: metaInfo,
            actionDatapoint: new PerformanceDatapoint(metaInfo.name, metaInfo.options),
        };
        let result;
        /* eslint-disable-next-line @typescript-eslint/no-unused-vars --
         * undefined
         *	> '_' is defined but never used. */
        addDatapointMiddleware(_ => {
            result = next && next(metaInfo, ctx, ...args);
        }, actionMsg);
        return result;
    } catch {
        return next && next(metaInfo, ctx, ...args);
    }
}
